import { SignedIn, SignedOut, SignIn } from '@clerk/clerk-react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { InstructorDashboard } from './features/instructor/InstructorDashboard';
import { Lobby } from './routes/Lobby';
import { LandingPage } from './routes/LandingPage';
import { StudentSession } from './features/student/StudentSession';
import { PostSessionReports } from './routes/PostSessionReports';
import { SessionHistory } from './routes/SessionHistory';
import { DailyProvider, DailyAudio } from '@daily-co/daily-react';
import { ProtectedLayout } from './components/auth/ProtectedLayout';

const App = () => {
  return (
    <DailyProvider>
      <DailyAudio />
      <Routes>
        
        {/* PUBLIC ROUTES */}
        <Route
          path="/"
          element={
            <>
              <SignedOut><LandingPage /></SignedOut>
              <SignedIn><Navigate to="/lobby" replace /></SignedIn>
            </>
          }
        />
        
        <Route
          path="/signin/*" 
          element={
            <>
              <SignedOut>
                <div className="flex min-h-screen items-center justify-center bg-background-main">
                  <SignIn routing="path" path="/signin" />
                </div>
              </SignedOut>
              <SignedIn><Navigate to="/lobby" replace /></SignedIn>
            </>
          }
        />

        {/* SHARED / GENERAL (Lobby) */}
        {/* ProtectedLayout handles the AppShell and Role Check */}
        <Route element={<ProtectedLayout />}>
          <Route path="/lobby" element={<Lobby />} />
        </Route>

        {/* STUDENT ONLY */}
        <Route element={<ProtectedLayout requiredRole="student" />}>
          <Route path="/session/:sessionId/student" element={<StudentSession />} />
        </Route>

        {/* 🔵 INSTRUCTOR ONLY */}
        <Route element={<ProtectedLayout requiredRole="instructor" />}>
          <Route path="/session/:sessionId/instructor" element={<InstructorDashboard />} />
          <Route path="/sessions" element={<SessionHistory />} />
          <Route path="/sessions/:sessionId" element={<PostSessionReports />} />
          <Route path="/session/:sessionId/report" element={<PostSessionReports />} />
        </Route>

        {/* CATCH ALL */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </DailyProvider>
  );
};

export default App;